var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mx-auto w-11-12 lg_w-1-2 xxl_w-5-12 my-2 lg_my-4" },
    [
      _c("observe", {
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var passes = ref.passes
              return [
                _c(
                  "form",
                  {
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        return passes(_vm.handleSubmit)
                      }
                    }
                  },
                  [
                    _c("form-field", {
                      attrs: {
                        label: "Email",
                        rules: "required|email",
                        value: _vm.email
                      },
                      on: {
                        input: function($event) {
                          return _vm.updateState(_vm.login, "email", $event)
                        }
                      }
                    }),
                    _c("form-field", {
                      attrs: {
                        "password-reveal": "password-reveal",
                        type: "password",
                        label: "Password",
                        rules: "required|min:6",
                        value: _vm.password
                      },
                      on: {
                        input: function($event) {
                          return _vm.updateState(_vm.login, "password", $event)
                        }
                      }
                    }),
                    _c(
                      "b-button",
                      {
                        staticClass: "mt-1",
                        attrs: {
                          outlined: "outlined",
                          expanded: "expanded",
                          size: "is-medium",
                          type: "is-primary",
                          "native-type": "submit",
                          loading: _vm.loading,
                          disabled: _vm.loading
                        }
                      },
                      [_vm._v("Sign in")]
                    )
                  ],
                  1
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }